import { Component, OnInit, Input } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { BridgeService } from 'src/app/services/bridge.service';
import { BscContractService } from 'src/app/services/bsc-contract.service';
import { CommonService } from 'src/app/services/common.service';
import { V2ContractService } from 'src/app/services/v2-contract.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

import { waitForTransaction } from '@wagmi/core'

import { writeContract } from '@wagmi/core';
const abi = require('src/contracts/abi-dev/bscBridge.json');
@Component({
  selector: 'app-bridge-transactions',
  templateUrl: './bridge-transactions.component.html',
  styleUrls: ['./bridge-transactions.component.css']
})
export class BridgeTransactionsComponent implements OnInit {

  @Input() migrateTransactions = [];
  mTransactions: any = [];
  account: any = {};
  isLoading: boolean = false;
  loadingRedeem: any = -1;
  transactions: any = {};
  decimals: number;
  config: any;
  display = 'none'; //default Variable

  constructor(
    private bridgeService: BridgeService,
    private accountService: AccountService,
    private v2ContractService: V2ContractService,
    private bscContractService: BscContractService,
    private commonService: CommonService,
    private toastr: ToastrService,

  ) { }

  ngOnInit(): void {
    this.mTransactions = this.migrateTransactions;
    this.accountService.accountObserve.subscribe((data) => {
      
      this.account = data;

      
      if (data.address != "") {
        this.getDecimals()
      }
      if (this.account.address !== "") {
        this.getRedeemTransactions();
      }
    });
   
  }

  getRedeemTransactions() {
    let query = {
      account: this.account.address,
      operation: environment.SUPPORTED_NETWORK[0] == this.account.chainId ? 'BSC-BURN' : 'ETH-BURN',
      current_page: 0,
      records_per_page: 20
    }

    this.bridgeService.getTransactions(query).subscribe((data) => {
      this.transactions = Object.assign({}, data);

    })
  }

  async getDecimals() {
    if (environment.SUPPORTED_NETWORK[0] == this.account.chainId) {
      this.decimals = 10 ** await this.v2ContractService.getDecimals() as any;
    } else {
      this.decimals = 10 ** await this.bscContractService.getDecimals() as any;
    }
  }

  redeem(transaction, index) {
    this.loadingRedeem = index;
    this.display = 'block';
    this.isLoading = true;
    let query = {
      from: transaction.from_address,
      to: transaction.to_address,
      amount: transaction.amount,
      nonce: transaction.nonce,
      signature: transaction.signature,
      transactionHash: transaction.transaction_hash,
    }
    //console.dir(query);
    if (transaction.operation === 'ETH-BURN') this.swapEthToBsc(query);
    else if (transaction.operation === 'BSC-BURN') this.swapBscToEth(query);
  }


  async swapEthToBsc(query) {

    let message = {
      from: this.account.address,
      to: environment.BSC_BRIDGE_ADDRESS,
      // data: redeemAbi,
      chainId: this.account.chainId,
      transactionHash: query.transactionHash
    }


    try {
      const { hash } = await writeContract({
        address: environment.BSC_BRIDGE_ADDRESS,
        abi: abi,
        functionName: 'mint',
        args: [query.from, query.to, query.amount, query.nonce, query.signature],
      })
      if (hash) {
        const _waitForTransaction = await waitForTransaction({
          confirmations: 1,
          hash: hash,
        })
          .then((receipt) => {
            this.loadingRedeem = -1;
            this.display = 'none';
            this.isLoading = false;
            this.toastr.success('Success');
            document.getElementById('close-modal').click();
            // Make an api call to remove transaction from db
            const param = { transactionHash:query.transactionHash };
            this.bridgeService.deleteTx(param).subscribe((result) => {

              window.location.reload();
            });

          })
          .catch((error) => {


            this.loadingRedeem = -1;
            this.display = 'none';
            document.getElementById('close-modal').click();
            this.isLoading = false;
            if (error.code === 4001)
              this.toastr.error('User rejected');
            else this.toastr.error('Transaction Failed');
          })
      }
    } catch (error: any) {

      this.loadingRedeem = -1;
      this.display = 'none';
      document.getElementById('close-modal').click();
      this.isLoading = false;

      if (error.code == 4001) {
        this.toastr.error('User rejected');
      } else {
        error = await JSON.stringify(error, null, 2);
        error = await JSON.parse(error);
        this.toastr.error(error.shortMessage);
      }

    }
  }


  async swapBscToEth(query) {

    let message = {
      from: this.account.address,
      to: environment.ETH_BRIDGE_ADDRESS,
      // data: redeemAbi,
      chainId: this.account.chainId,
      transactionHash: query.transactionHash
    }

    try {
      const { hash } = await writeContract({
        address: environment.ETH_BRIDGE_ADDRESS,
        abi: abi,
        functionName: 'mint',
        args: [query.from, query.to, query.amount, query.nonce, query.signature],
      })
      if (hash) {
        const _waitForTransaction = await waitForTransaction({
          confirmations: 1,
          hash: hash,
        })
          .then((receipt) => {
            this.loadingRedeem = -1;
            this.display = 'none';

            this.isLoading = false;
            this.toastr.success('Success');
            document.getElementById('close-modal').click();
            // Make an api call to remove transaction from db
            const param = { transactionHash: query.transactionHash };
            this.bridgeService.deleteTx(param).subscribe((result) => {

              window.location.reload();
            });

          })
          .catch((error) => {

            this.loadingRedeem = -1;
            this.display = 'none';
            document.getElementById('close-modal').click();
            this.isLoading = false;
            if (error.code === 4001)
              this.toastr.error('User rejected');
            else this.toastr.error('Transaction Failed');
          })
      }
    } catch (error: any) {

      this.loadingRedeem = -1;
      this.display = 'none';
      document.getElementById('close-modal').click();
      this.isLoading = false;

      if (error.code == 4001) {
        this.toastr.error('User rejected');
      } else {
        error = await JSON.stringify(error, null, 2);
        error = await JSON.parse(error);
        this.toastr.error(error.shortMessage);
      }

    }
  }

}
